import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilService } from 'src/app/service/util.service';


@Component({
  selector: 'demo-dm-result-panel',
  templateUrl: './demo-dm-result-panel.html'
})
export class DEmoDmResultPanel implements OnInit {
  preQualObj: any;

  constructor(private utilService: UtilService, private router: Router, private _activatedRoute: ActivatedRoute) {
    this.utilService.isSidebarVisible.next(false);
  }

  ngOnInit(): void {
  }
  dmResponse(status) {
    if (status === 'failed') {
      this.router.navigate(['../request-callback'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
    } else {
      this.router.navigate(['../summary'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
    }
  }

}


